// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3VDl0","box":"WorkspacesBox_box__PhZxw","node":"WorkspacesBox_node__2e9So"};